import Login from '../components/general/Login.vue';
import Logout from '../components/general/Logout.vue';
import PasswordReset from '../components/general/PasswordReset.vue';
import PasswordResetConfirmation from '../components/general/PasswordResetConfirmation.vue';

export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
	name: "Login",
	path: '/login',
	component: Login
  },
  {
    name: "Logout",
	path: '/logout',
	component: Logout
  },
  {
    path: '/reset-password',
    component: PasswordReset
  },
  {
    path: '/reset-password/:hash',
    component: PasswordResetConfirmation
  }
]



// WEBPACK FOOTER //
// ./src/router/BaseRoutes.js